import React from 'react'

const Blog3banner = () => {
  return (
    <>
     <section className="tf-slider blog3  parallax blog-banner-image">
            <div className="content"></div>
            <div className="container ">
                <div className="row ">
                    <div className="col-lg-12">
                        {/* <FormContent /> */}
                    </div>
                </div>
            </div>
            <div className="overlay"></div>
        </section>
    </>
  )
}

export default Blog3banner